import { useDrag } from "react-dnd";
import { useDispatch } from "react-redux";
import { ItemTypes } from "../../../abstract/controller/enum/dnd/ItemTypes";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import * as uuidUtils from "../../../abstract/controller/utils/uuidUtils";
import { setDrag, setIdle } from "../../../abstract/redux/slice/statusSlice";
import styles from "./ChoiceMain.module.scss";
import ChoiceOptions from "./ChoiceOptions";
import { useState } from "react";

function ChoiceMain({ node, children }) {
  const _dispatch = useDispatch();

  const [_isMouseOver, _setMouseOver] = useState(false);

  const _id = nodeUtils.getID(node);
  const _uuid = nodeUtils.getUUID(node);
  const _m_uuid = uuidUtils.getMainUuid(_uuid);
  const _isAbstract = nodeUtils.isAbstract(node);

  //---------------------------------------------------------------------

  const [, drag] = useDrag(() => ({
    type: ItemTypes.CHOICE,
    item: { element: node },
  }), [node]);

  //---------------------------------------------------------------------

  const handleOnDragStart = (e) => {
    if (e.target.id.includes(_uuid)) {
      const _element = document.querySelector(`#${_m_uuid}`);
      const _size = _element.getBoundingClientRect();
      _dispatch(setDrag({ id: _id, size: { width: _size.width, height: _size.height } }));
    }
  };

  const handleOnDragEnd = () => {
    _dispatch(setIdle());
  };

  const handleOnMouseEnter = (e) => {
    e?.stopPropagation();

    _setMouseOver(true);
  };

  const handleOnMouseLeave = (e) => {
    e?.stopPropagation();

    _setMouseOver(false);
  };

  const canDrag = () => {
    return Boolean(nodeUtils.getName(node));
  };

  return (
    <div
      id={_m_uuid}
      className={`${styles["main"]} ${_isAbstract ? styles[`style-nesting-0`] : styles[`style-nesting-limit`]}`}
      ref={canDrag() ? drag : null}
      onDragStart={handleOnDragStart}
      onDragEnd={handleOnDragEnd}
      onMouseOver={handleOnMouseEnter}
      onMouseOut={handleOnMouseLeave}>
      {children}
      <ChoiceOptions id={_id} node={node} isMouseOver={_isMouseOver} />
    </div>
  );
}

export default ChoiceMain;
